export default __webpack_public_path__ + "static/media/placeholder-tape.00cfebd2.webp";